import React from 'react';

const PRESETS = [
  ['today',      'Today'],
  ['yesterday',  'Yesterday'],
  ['this_week',  'This week'],
  ['this_month', 'This month'],
  ['last_7',     'Last 7d'],
  ['last_30',    'Last 30d'],
  ['custom',     'Custom…'],
];

export default function RangeBar({ value, onChange }) {
  const { preset, start, end } = value;
  const setPreset = (p) => onChange({ ...value, preset: p });
  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="flex flex-wrap items-center gap-2 mb-4">
      {PRESETS.map(([k, label]) => (
        <button
          key={k}
          type="button"
          onClick={() => setPreset(k)}
          className={
            'px-3 py-1.5 rounded-thin text-xs border transition-colors ' +
            (preset === k
              ? 'bg-continuum-500 text-white border-continuum-500'
              : 'border-surface-border dark:border-surface-dark-border hover:bg-surface-subtle dark:hover:bg-surface-dark-subtle')
          }
        >
          {label}
        </button>
      ))}
      {preset === 'custom' && (
        <div className="flex items-center gap-1 text-xs">
          <input
            type="date"
            max={today}
            value={start || ''}
            onChange={(e) => onChange({ ...value, start: e.target.value })}
            className="px-2 py-1 rounded-thin border border-surface-border dark:border-surface-dark-border bg-surface-base dark:bg-surface-dark-base"
          />
          <span className="text-surface-muted">to</span>
          <input
            type="date"
            max={today}
            value={end || ''}
            onChange={(e) => onChange({ ...value, end: e.target.value })}
            className="px-2 py-1 rounded-thin border border-surface-border dark:border-surface-dark-border bg-surface-base dark:bg-surface-dark-base"
          />
        </div>
      )}
    </div>
  );
}
